import { render } from "./CompetenceModalImport.vue?vue&type=template&id=2ff1f110"
import script from "./CompetenceModalImport.vue?vue&type=script&lang=js"
export * from "./CompetenceModalImport.vue?vue&type=script&lang=js"

import "./CompetenceModalImport.vue?vue&type=style&index=0&id=2ff1f110&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__